import React from 'react';
import PackageCard from '@components/shared/PrincingCardsV2/PackageCard/PackageCard';
import {
  PACKAGES,
  PACKAGE_DETAILS,
  PACKAGE_NAMES
} from '@components/shared/PrincingCardsV2/common';
import { useRouter } from 'next/router';
import useHolidaySale from '@hooks/useHolidaySale/useHolidaySale';
import PriceLabel from './PriceLabel/PriceLabel';

export default function PackageCards() {
  const router = useRouter();
  const holidaySale = useHolidaySale();

  const handleCTA = (pkg: PACKAGES) => {
    let giftQuery = 'ONLINE';

    if (pkg === PACKAGES.MERCH) {
      giftQuery = 'MERCH_ONLY';
    } else if (pkg === PACKAGES.AT_HOME) {
      giftQuery = 'IN_PERSON';
    }

    return router.push(`/gift/checkout?gift=${giftQuery}`);
  };

  return (
    <>
      <PackageCard
        CTA={handleCTA}
        type={PACKAGE_NAMES.FULL}
        holidaySale={holidaySale}
        title={PACKAGE_DETAILS[PACKAGE_NAMES.FULL].title}
        useCase={PACKAGE_DETAILS[PACKAGE_NAMES.FULL].description}
        ctaText="GIFT ONLINE DESIGN"
      />
      <PackageCard
        CTA={handleCTA}
        type={PACKAGE_NAMES.AT_HOME}
        holidaySale={holidaySale}
        title={PACKAGE_DETAILS[PACKAGE_NAMES.AT_HOME].title}
        useCase={PACKAGE_DETAILS[PACKAGE_NAMES.AT_HOME].description}
        showLocations
        locations={PACKAGE_DETAILS[PACKAGE_NAMES.AT_HOME].locations}
        ctaText="GIFT IN-PERSON DESIGN"
      />
      <PackageCard
        CTA={handleCTA}
        type={PACKAGE_NAMES.MERCH}
        title={'Merch Credit'}
        useCase={`Who doesn’t love a little spending cash? Help friends and family buy all the
        items their designer recommends.`}
        priceLabel={<PriceLabel value={'Your Choice'} />}
        ctaText="GIFT MERCH CREDIT"
      />
    </>
  );
}
